"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import CarouselTiles from "./CarouselTiles";
import { action, observable } from "mobx";
let Carousel = class extends React.Component {
  constructor(props) {
    super(props);
    this.scrollContainer = null;
    this.scrollBehavior = "smooth";
    this.onScroll = this.onScroll.bind(this);
  }
  componentDidMount() {
    this.props.carouselControllerStore.registerScrollCallback(this.triggerScroll.bind(this));
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener("scroll", this.onScroll);
    }
    this.onScroll();
  }
  render() {
    const { allowManualScrolling, onResize, componentWidth, componentHeight } = this.props.carouselControllerStore;
    const overflowType = allowManualScrolling ? "auto" : "hidden";
    return /* @__PURE__ */ React.createElement("div", { className: "carousel" }, /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: true, onResize }), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "carousel__scroll-container",
        style: {
          overflowX: overflowType,
          scrollBehavior: this.scrollBehavior
        },
        ref: (elem) => {
          this.scrollContainer = elem;
        }
      },
      !!componentWidth && !!componentHeight && /* @__PURE__ */ React.createElement(CarouselTiles, { carouselControllerStore: this.props.carouselControllerStore })
    ));
  }
  onScroll() {
    if (this.scrollContainer) {
      const { setScrollPosition } = this.props.carouselControllerStore;
      setScrollPosition(this.scrollContainer.scrollLeft);
    }
  }
  triggerScroll(scrollTarget, immediate) {
    const newBehaviour = immediate ? "auto" : "smooth";
    if (newBehaviour !== this.scrollBehavior) {
      this.scrollBehavior = newBehaviour;
    }
    setTimeout(() => {
      if (this.scrollContainer) {
        this.scrollContainer.scrollLeft = scrollTarget;
      }
    }, 0);
  }
};
__decorateClass([
  observable.ref
], Carousel.prototype, "scrollBehavior", 2);
__decorateClass([
  action
], Carousel.prototype, "triggerScroll", 1);
Carousel = __decorateClass([
  observer
], Carousel);
export {
  Carousel as default
};
